import type { IssueType } from '@prisma/client';
import { issueTypeToDisplay } from './IssueTypeButton';
import { HoverCard } from '@mantine/core';

export default function IssueTypeBadge({ issueType, isResolved }: { issueType: IssueType; isResolved: boolean }) {
  return (
    <div className="flex items-center gap-2">
      <HoverCard
        width={280}
        shadow="md"
        withArrow
        openDelay={200}
        closeDelay={400}
      >
        <HoverCard.Target>
          <div
            className={`rounded-md px-2 py-1 text-xs font-medium ${
              isResolved ? 'bg-gray-100 text-gray-500 dark:bg-stone-600/40'
              : issueType === 'BUG' ? 'bg-red-100 text-red-800 dark:bg-red-800/40 dark:text-red-200'
              : issueType === 'NEEDS_REWRITE' ? 'bg-blue-100 text-blue-800 dark:bg-blue-800/40 dark:text-blue-200'
              : issueType === 'FLAKE' ? 'bg-yellow-100 text-yellow-800 dark:bg-yellow-800/40 dark:text-yellow-200'
              : issueType === 'UI_CHANGE' ? 'bg-violet-100 text-violet-800 dark:bg-violet-800/40 dark:text-violet-200'
              : 'bg-gray-100 text-gray-800 dark:bg-stone-600/40 dark:text-gray-200'
            }`}
          >
            {issueTypeToDisplay(issueType)}
          </div>
        </HoverCard.Target>
        {issueType === 'FLAKE' && (
          <HoverCard.Dropdown>
            <div className="flex flex-col space-y-2 text-sm">
              <div className="font-bold text-blue-700">What does this mean?</div>
              <div>We automatically retries tests so flakiness won&apos;t fail your tests.</div>
              <div>However, we do suggest fixing them because they can slow down your test runs.</div>
            </div>
          </HoverCard.Dropdown>
        )}
      </HoverCard>
    </div>
  );
}
